import "./index.css";
import logo_redcap from "./redcap_logo.png";
import logo_unc from "./University_Signature_CarolinaBlue_rgb_h.svg";
import { ExternalLink } from "lucide-react";

const instances = [
  {
    label: "RSC",
    name: "REDCap Research (formerly RC2)",
    desc: "Primary REDCap environment for UNC research projects.",
    url: "https://rsc.redcap.unc.edu",
    badge: "Research",
  },
  {
    label: "OPS",
    name: "REDCap Operation",
    desc: "REDCap environment for non-research, research supporting projects.",
    url: "https://ops.redcap.unc.edu",
    badge: "Operational",
  },
  {
    label: "RC1",
    name: "RC1",
    desc: "Original REDCap environment for UNC research projects. Projects in this environment will be migrated to Research REDCap.",
    url: "https://rc1.redcap.unc.edu",
    badge: "Research",
  },
  {
    label: "GLOBAL",
    name: "Global REDCap",
    desc: "REDCap environment for UNC international research projects. Projects in this environment will be migrated to Research REDCap.",
    url: "https://global.redcap.unc.edu",
    badge: "Research",
  },
  {
    label: "LEARN",
    name: "Learn",
    desc: "Sandbox environment for testing and learning REDCap. Do not enter real study data.",
    url: "https://learn.redcap.unc.edu",
    badge: "Sandbox",
  },
];

const badgeClass = {
  Research: "badge-research",
  Sandbox: "badge-sandbox",
  Operational: "badge-operational",
};

export default function App() {
  return (
    <div className="page">
      <header className="hdr">
        <div className="hdr-inner">
          <img src={logo_unc} alt="UNC-Chapel Hill Logo" className="logo" />
          <img src={logo_redcap} alt="REDCap Logo" className="logo" />
        </div>
      </header>

      <main className="main">
        <div className="page-head">
          <p>Select a REDCap environment below to continue.</p>
          <div className="page-head-actions">
            <a
              href="https://researchdata.unc.edu/redcap"
              target="_blank"
              rel="noreferrer noopener"
              className="head-btn"
            >
              UNC REDCap Info
            </a>
            <a
              href="https://go.unc.edu/REDCapAnnouncements"
              target="_blank"
              rel="noreferrer noopener"
              className="head-btn"
            >
              Subscribe Announcements
            </a>
            <a
              href="https://go.unc.edu/redcap-request"
              target="_blank"
              rel="noreferrer noopener"
              className="head-btn"
            >
              Submit Request
            </a>
          </div>
        </div>

        <div className="grid">
          {instances.map((inst) => (
            <div className="card" key={inst.url}>
              <div className="card-name">
                {inst.name}
                <span className={`badge ${badgeClass[inst.badge] || "badge-research"}`}>
                  {inst.badge}
                </span>
              </div>

              <div className="card-desc">{inst.desc}</div>

              <div className="card-footer">
                <span className="card-url">
                  {inst.url.replace("https://", "")}
                </span>
                <a
                  className="btn"
                  href={inst.url}
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  Open
                  <ExternalLink size={14} strokeWidth={2.2} />
                </a>
              </div>
            </div>
          ))}
        </div>
      </main>

      <footer className="ftr">
        © 2026&nbsp;
        <a
          href="https://www.unc.edu/"
          target="_blank"
          rel="noreferrer noopener"
          className="footer-link"
        >
          University of North Carolina at Chapel Hill&nbsp;
        </a>
        /&nbsp;
        <a
          href="https://researchdata.unc.edu/"
          target="_blank"
          rel="noreferrer noopener"
          className="footer-link"
        >
          Research Data Management Core&nbsp;
        </a>
        <br />All rights reserved.
      </footer>
    </div>
  );
}